import React from 'react'
import styled from 'styled-components'
import { INVESTOR_NOTICE } from '@constants/notice'

const Index = () => {
  return (
    <Container>
      <Text>
        <Title>유의사항</Title>
        <Desc>
          {INVESTOR_NOTICE.map((itm, index) => {
            return (
              <ListContainer key={index}>
                <Dot>·</Dot>
                <Content>{itm}</Content>
              </ListContainer>
            )
          })}
        </Desc>
        <Compliance>
          엠엘광고준법 심사필 2024-제20호 : 2024.11.4 ~ 2025.11.3
        </Compliance>
      </Text>
    </Container>
  )
}

const Container = styled.div`
  padding: 32px 0;
  box-sizing: border-box;
  background-color: #e9ebf2;
  min-width: 360px;
  width: 100%;
  display: flex;
  justify-content: center;
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 360px;
  padding: 0 24px;
  font-family: 'Spoqa Han Sans Neo', sans-serif;
`

const Title = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: #808491;
`
const Desc = styled.ul`
  display: flex;
  flex-direction: column;
  color: #808491;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  max-width: 100%;
  gap: 2px;
`

const Dot = styled.div`
  width: 13px;
  flex-shrink: 0;
`

const Content = styled.div`
  flex-grow: 1;
  color: #808491;
  font-family: Pretendard, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`

const ListContainer = styled.li`
  display: flex;
  align-items: flex-start;
`

const Compliance = styled.div`
  color: #808491;
  font-family: Pretendard, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-top: 13px;
`

export default Index
